import { RecordPageRenderContext, JsonSchemaProperty } from "../../../../types";
import { RecordPageFieldLayout } from "../../../../utils/styled";
import { resolveCustomStyle } from "../../style-config";
import DynamicFieldRenderer from "../renderers/DynamicFieldRenderer";

export function renderField(
  propertyKey: string,
  ctx: RecordPageRenderContext,
  explicitProperty?: JsonSchemaProperty,
): JSX.Element | null {
  const property = explicitProperty ?? ctx.schema.properties[propertyKey];
  if (!property) return null;

  return (
    <RecordPageFieldLayout
      key={propertyKey}
      $customStyle={resolveCustomStyle({
        applicability: "field",
        propertyKey,
        property,
        selectedSetup: ctx.selected.setup.value,
        isHidden: property.isHidden,
      })}
    >
      <DynamicFieldRenderer
        propertyKey={propertyKey}
        property={property}
        rowDataReducerState={ctx.rowDataReducerState}
        dispatch={ctx.dispatch}
      />
    </RecordPageFieldLayout>
  );
}
